import * as angular from 'angular';
import * as _ from 'lodash';
import template from './copySectionChange.tpl.html';
import {Strategy} from "./sectionChange";
import {Plant} from "../../models/navigation";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import SectionChangeServiceName, {SectionChangeService} from "../../services/toolChange/sectionChange.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import {CheckListCommon} from "../../models/checkLists/checkListOverride.module";
import AuthDataServiceName, {AuthDataService} from "../../services/auth/authData.service";
import {apsCommands} from "../../shared/dto/aps.commands";

let requires = [SectionChangeServiceName, LoaderServiceName, NotifyServiceName, NewGuidServiceName,
  AuthDataServiceName];

export interface CopySectionChangeControllerData {
  originalStrategy: Strategy;
  plants: Plant[];
}

export function openCopySectionChange(data: CopySectionChangeControllerData,
                                      $modal: mm.foundation.modal): angular.IPromise<Strategy> {
  return $modal.open({
    template: template,
    controller: 'CopySectionChangeCtrl as vm',
    resolve: {
      data: function() {
        return data;
      }
    }
  }).result;
}

interface CopySectionChangeController {
  form: angular.IFormController;

  plants: Plant[];
  shops: apsViewModels.ShopNavigation[];
  shops_filtered(): apsViewModels.ShopNavigation[];

  id: string;
  originalStrategy: Strategy;
  name: string;
  plant: Plant;
  shop: apsViewModels.ShopNavigation;

  submit(): void;
  cancel(): void;
}

export default angular.module('aps.controller.copySectionChange', requires)
  .controller('CopySectionChangeCtrl', copySectionChangeCtrl)
  .name;

function copySectionChangeCtrl(
  $modalInstance: mm.foundation.modalInstance,
  data: CopySectionChangeControllerData,
  sectionChangeService: SectionChangeService,
  loaderService: LoaderService,
  notifyService: NotifyService,
  newGuidService: NewGuidService,
  authDataService: AuthDataService
) {
  let vm = <CopySectionChangeController>{};

  let isAdmin = authDataService.isAdmin();

  vm.originalStrategy = data.originalStrategy;
  vm.name = 'Copy of ' + vm.originalStrategy.name;

  let shopsAllSelection = CheckListCommon.getAllShopsItem();
  let plantsAllSelection = CheckListCommon.getAllPlantsItem();

  if (isAdmin) {
    vm.plants = data.plants;
    vm.plant = plantsAllSelection;
  } else {
    vm.plants = _.filter(data.plants, (plant) => authDataService.isPlantAdmin(plant.id));
    vm.plant = vm.plants[0];
  }

  vm.shop = shopsAllSelection;

  newGuidService.getNewGuid('checkList').then(id => vm.id = id);

  vm.submit = () => {

    if (vm.form.$invalid) {
      return;
    }

    let plant = vm.plant !== plantsAllSelection ? vm.plant : undefined;
    let shop = vm.shop !== shopsAllSelection ? vm.shop : undefined;

    let command: apsCommands.CopySectionChangeStrategy = {
      id: vm.id,
      originalId: vm.originalStrategy.id,
      name: vm.name,
      plantId: plant ? plant.id : null,
      shopId: shop ? shop.id : null
    };

    let promise = sectionChangeService.copyStrategy(command).then(() => {
      let strategy: Strategy = {
        id: vm.id,
        name: vm.name,
        canEdit: true,
        configs: null,
        isDefault: false,
        plantId: command.plantId,
        plantName: plant ? plant.name : 'All',
        shopId: command.shopId,
        shopName: shop ? shop.name : 'All'
      };
      $modalInstance.close(strategy);
    }, notifyService.handleApiErrors);

    loaderService.loadingPromise(promise);
  };

  vm.cancel = () => {
    $modalInstance.close();
  };

  vm.shops_filtered = () => {
    let result = <apsViewModels.ShopNavigation[]>vm.plant.shops.concat([]);
    if (result.length === 0 || result[0] !== shopsAllSelection) {
      result.unshift(shopsAllSelection);
    }

    if (result.length === 1) {
      vm.shop = result[0];
    }

    return result;
  };

  return vm;
}


// WEBPACK FOOTER //
// ./src/app/controllers/sectionChange/copySectionChange.controller.ts